import React from 'react'
import { Swiper, SwiperSlide } from "swiper/react";
import { Navigation } from "swiper/modules";
import "swiper/css";
import "swiper/css/navigation";

const YachtSlider = ({yachtImages}) => {
    return (
        <Swiper className="yachtsSwiper1" loop={true} modules={[Navigation]} navigation>
            {yachtImages.map((img, index) => (
                <SwiperSlide key={index}>
                    <img src={img.image} className="card-img-top" alt={`Yacht Image ${index + 1}`} />
                </SwiperSlide>
            ))}
        </Swiper>
    )
}

export default YachtSlider